import React from "react"
import Button from "components/common/Button"
import CheckBox from "components/checkbox"
import { useState } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import { isMobile } from "react-device-detect"

import styled from "styled-components"

const HTMLContainer = styled.div`
  text-align: justify;
  margin-bottom: 32px;

  .buttonc {
    margin-top: 32px;
  }
  .buttonc button {
    margin-right: 10px;
  }
  p {
    align: center;
  }
`

const PdfSection = ({ coursewareDetails, config, onMarkComplete }) => {
  let url = ""
  if (coursewareDetails.type === "link") {
    url = coursewareDetails.url
  } else {
    let pdfUrl = config?.pdf_download
      ? coursewareDetails.file
      : `${coursewareDetails.file}#toolbar=0`
    url = pdfUrl
  }

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [pageScale, setPageScale] = useState(1)

  /*When document gets loaded successfully*/
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
    setPageNumber(1)
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset)
  }

  const previousPage = () => {
    changePage(-1)
  }

  const nextPage = () => {
    changePage(1)
  }

  function handleZoomIn() {
    if (pageScale < 3) {
      setPageScale(pageScale + 0.2)
    }
  }

  function handleZoomOut() {
    if (pageScale > 0.3) {
      setPageScale(pageScale - 0.2)
    }
  }

  const handleDownload = () => {
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob)

        // Setting various property values
        let alink = document.createElement("a")
        alink.href = fileURL
        alink.download = coursewareDetails?.name
        alink.click()
      })
    })
  }

  const showZoomInstruction = coursewareDetails.type !== "link"

  return (
    <>
      <div className="checkbox-container">
        <CheckBox
          text="Mark as Complete"
          value={coursewareDetails.completed}
          checked={coursewareDetails.completed}
          id={`chk-complete-${coursewareDetails.id}`}
          tooltip="You are required to Mark this as Completed to complete your progress"
          onClick={() => (onMarkComplete ? onMarkComplete() : false)}
        />
        <p>
          You are required to Mark this as Completed to complete your progress
        </p>
      </div>
      <div className="courseware-details">
        <h2 className="courseware-title">{`${coursewareDetails.name}`}</h2>
        {coursewareDetails.description && (
          <p className="courseware-description">
            {coursewareDetails.description}
          </p>
        )}
      </div>
      {coursewareDetails.type === "pdf" && isMobile ? (
        <div className="pdf-container">
          {config?.pdf_download && (
            <HTMLContainer>
              <Button
                label="Download PDF"
                size="small"
                outlined={false}
                onClick={() => handleDownload()}
              />
            </HTMLContainer>
          )}
          <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} scale={pageScale} />
          </Document>
          <div className="pagec">
            Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
          </div>
          {/* <button onClick={handleZoomIn} disabled={pageScale >= 3}>
            Zoom +
          </button>
          <button onClick={handleZoomOut} disabled={pageScale <= 0.3}>
            Zoom -
          </button> */}
          <HTMLContainer>
            <div className="buttonc">
              <Button
                label="Previous"
                color="black"
                outlined
                disabled={pageNumber <= 1}
                onClick={() => previousPage()}
              />
              <Button
                label="Next"
                color="black"
                outlined
                disabled={pageNumber >= numPages}
                onClick={() => nextPage()}
              />
            </div>
          </HTMLContainer>
        </div>
      ) : (
        <div className="pdf-container">
          <iframe title={coursewareDetails.name} src={url} />
          {showZoomInstruction && (
            <p className="instruction-text">
              Zoom: Scroll up or down while holding Ctrl button.
            </p>
          )}
        </div>
      )}
    </>
  )
}

export default PdfSection
